/* eslint-disable react/no-array-index-key */
import React, { useEffect, useRef } from 'react';
import { Box, VStack, Button, Icon, Spacer, Collapse } from '@chakra-ui/react';
import { RiLogoutBoxRFill } from 'react-icons/ri';

import logo from '../../../assets/images/logo.svg';

import { useLogout } from '../../../lib/auth-provider/context/hooks';

import { Logo } from './logo';
import { useSubmenu } from '../../context';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../lib/auth-provider/context';
import { FaBook, FaLayerGroup, FaRegClock } from 'react-icons/fa';
import { FiUsers } from 'react-icons/fi';
import { useMenuItems } from '../../constants';
import { MenuBadge, sumChildBadges } from './menu-badge';

function NavigationDrawer({
  isOpen = false,
  onToggleNavigationDrawer,
  ...properties
}) {
  const navigate = useNavigate();
  const [logout] = useLogout();
  const { user } = useAuth();
  const location = useLocation().pathname;
  const { subMenu, setSubMenu } = useSubmenu();
  const isMenuItemAdded = useRef(false);
  const MENU_ITEMS = useMenuItems();

  const handleClickSubMenu = (key, item) => {
    const filterMenu = subMenu.filter((itemFilter) => itemFilter !== key);
    if (item.children.length !== 0) {
      if (!subMenu.includes(key)) {
        setSubMenu([...subMenu, key]);
      } else {
        setSubMenu(filterMenu);
      }
    } else {
      navigate(item.to);
    }
  };

  useEffect(() => {
    MENU_ITEMS.some((val, index) => {
      const hasActiveChild = val.children?.some(
        (item) => item.to === `/${location}`,
      );
      if (hasActiveChild) {
        setSubMenu([index]);
      }
      return hasActiveChild;
    });
  }, [location, setSubMenu]);

  useEffect(() => {
    if (user?.idSchool?.schoolType === 'pkbm' && !isMenuItemAdded.current) {
      const pkbmMenuExists = MENU_ITEMS.some(
        (val) => val.groupTitle === 'PKBM',
      );

      if (!pkbmMenuExists) {
        MENU_ITEMS.push({
          groupTitle: 'PKBM',
          icon: FaLayerGroup,
          children: [
            {
              title: 'Manajeman Siswa',
              icon: FiUsers,
              to: '/pkbm/manajeman-siswa',
            },
            {
              title: 'Program Mapel',
              icon: FaBook,
              to: '/pkbm/program-mata-pelajaran',
            },
            {
              title: 'Riwayat Siswa',
              icon: FaRegClock,
              to: '/pkbm/riwayat-siswa',
            },
          ],
        });
        isMenuItemAdded.current = true;
      }
    }
  }, [user]);

  return (
    <>
      <Box
        as="nav"
        top="0"
        height="100vh"
        width="256px"
        py="32px"
        px="24px"
        shadow="xl"
        zIndex={7}
        position="fixed"
        transform="translateX(0%)"
        maxHeight="calc(100% - 0px)"
        backgroundColor="white"
        overflow="scroll"
        left={{ base: isOpen ? '0' : '-256px', md: '0' }}
        transition="left 0.5s, right 0.5s"
        {...properties}
      >
        <Logo src={logo} alt="wish-logo" />
        <VStack spacing="16px" align="start">
          {MENU_ITEMS.map((item, index) => {
            return (
              <Box key={index} w={'full'}>
                <Button
                  cursor={'pointer'}
                  fontSize="13px"
                  lineHeight={4}
                  fontWeight="medium"
                  textTransform="uppercase"
                  color="gray.600"
                  size={'sm'}
                  px={4}
                  mt={1}
                  bg={'white'}
                  w={'full'}
                  // textAlign={'left'}
                  display={'flex'}
                  justifyContent={'start'}
                  leftIcon={<item.icon />}
                  isActive={
                    item.to === `/${location}` ||
                    item?.children?.some((some) => some.to === `${location}`)
                  }
                  _active={{ bg: 'cyan.700', color: 'white' }}
                  key={index}
                  onClick={() => handleClickSubMenu(index, item)}
                >
                  {item.groupTitle}
                  {/* Grup tertutup: angka anak-anaknya tampil di sini. */}
                  {!subMenu.includes(index) && (
                    <MenuBadge count={sumChildBadges(item.children)} />
                  )}
                </Button>

                {/* SUBMENU */}
                <Collapse in={subMenu.includes(index)} animateOpacity>
                  {item.children?.map((itemChild, key) => {
                    return (
                      <Button
                        key={key}
                        leftIcon={<itemChild.icon />}
                        textDecoration={
                          itemChild.to === `/${location}` && 'underline'
                        }
                        fontSize="sm"
                        height="36px"
                        width="100%"
                        lineHeight={5}
                        variant="ghost"
                        color="gray.600"
                        iconSpacing="12px"
                        fontWeight="medium"
                        _active={{ color: 'cyan.700' }}
                        isActive={itemChild.to === `${location}`}
                        colorScheme="cyan"
                        justifyContent="start"
                        borderBottom="1px"
                        borderColor="gray.200"
                        onClick={() => {
                          navigate(itemChild.to);
                        }}
                        my={3}
                        ml={2}
                      >
                        {itemChild.title}
                        <MenuBadge count={itemChild.badge} />
                      </Button>
                    );
                  })}
                </Collapse>
              </Box>
            );
          })}
          <Spacer />
          <Button
            fontSize="sm"
            height="36px"
            lineHeight={5}
            variant="ghost"
            color="gray.600"
            iconSpacing="12px"
            fontWeight="medium"
            colorScheme="blue"
            justifyContent="start"
            leftIcon={
              <Icon as={RiLogoutBoxRFill} color="gray.400" w="12px" h="12px" />
            }
            type="button"
            onClick={logout}
          >
            Logout
          </Button>
        </VStack>
      </Box>
      <Box
        as="div"
        position="fixed"
        top="0"
        right="0"
        height="100vh"
        width="100%"
        bg="rgba(0, 0, 0, 0.5)"
        zIndex={6}
        display={{ base: isOpen ? 'block' : 'none', md: 'none' }}
        transition="opacity 0.2s ease-in-out"
        onClick={onToggleNavigationDrawer}
      />
    </>
  );
}

export { NavigationDrawer };
